export const boardDisplayKeys = {
  "status": {
    "draft": "boardPortal.draft",
    "pending": "boardPortal.pendingForOpen",
    "pending_open": "boardPortal.pendingForOpen",
    "open": "boardPortal.open",
    "closed": "boardPortal.closed",
    "withdrawn": "boardPortal.withdrawn"
  },
  "vote": {
    "yes": "boardPortal.yes",
    "no": "boardPortal.no",
    "abstain": "boardPortal.abstain"
  },
  "result": {
    "approved": "boardPortal.approved",
    "rejected": "boardPortal.rejected"
  },
  "memberType": {
    "member": "boardPortal.member",
    "staff": "boardPortal.staff",
    "external": "boardPortal.external"
  },
  "action": {
    "created": "boardPortal.motionCreated",
    "submitted": "boardPortal.motionSubmitted",
    "opened": "boardPortal.motionOpened",
    "voted": "boardPortal.voteRecorded",
    "closed": "boardPortal.motionClosed",
    "approved": "boardPortal.motionApproved",
    "rejected": "boardPortal.motionRejected",
    "withdrawn": "boardPortal.motionWithdrawn",
    "locked": "boardPortal.budgetLocked",
    "unlocked": "boardPortal.budgetUnlocked",
    "budget_created": "boardPortal.budgetCreated"
  }
};
export const boardDisplay = (t, group, value) => boardDisplayKeys[group]?.[value] ? t(boardDisplayKeys[group][value]) : value;

export const boardFinancialLabel = (t, row) => ['other', 'uncategorized'].includes(row.system_category) ? t(`boardPortal.${row.system_category}`) : row.name;
